
import rem from '@/utils/rem';
import {ref, reactive, toRaw} from 'vue';
import {Toast} from 'vant'
import {defineComponent} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import tokenUtil from "@/utils/TokenUtil";
import apiUtil from "@/apiUtil";

export default defineComponent({
  name: "pingweiServiceLogin",
  setup() {
    rem(750, 750)
    let code = reactive({
      time: 0,
      flag: false
    })
    const time = ref(30 * 60 * 60 * 1000);
    const route = useRoute()
    const router = useRouter()
    const show = ref(true)
    const loginInfo = reactive({
      phone: "",
      code: "",
    })

    const login = async () => {
      if (!loginInfo.phone) {
        Toast('请输入您的手机号')
        return
      }
      if (!loginInfo.code) {
        Toast('请输入您的验证码')
        return
      }
      const res = await apiUtil.apiUtilPost('/api/pkbuser/login/byPhone', {
        phone: loginInfo.phone,
        code: loginInfo.code
      })
      if (res.code === 0) {
        tokenUtil.setToken(res.data.token)
        await router.replace('/pingweiService/serviceList')
      } else {
        Toast.fail(res.message)
      }
    }
    const getCode = async () => {
      let res = await apiUtil.apiUtilPost('/api/pkbuser/msg/send', {
        phone: loginInfo.phone,
        sendMessageTypeEnum: 'LOGIN'
      })
      console.log(res)
      if (res.code === 0) {
        code.flag = true
        code.time = 60 * 1000
      } else {
        Toast.fail(res.message)
        code.flag = false
      }
    }

    const onFinish = () => {
      code.flag = false
    }

    return {
      loginInfo,
      login,
      show,
      getCode,
      code,
      onFinish,
      time
    };
  }
})
